import { DraftailEditor, ENTITY_TYPE } from "draftail";

import ImageBlock from "../Blocks/ImageBlock";
import FullImageBlock from "../Blocks/FullWidthImageBlock";
import ImageSource from "../Sources/ImageSource";
import FullImageSource from "../Sources/FullWidthImageSource";
import CredentialNameSource from "../Sources/CredentialNameSource";
import RecipientNameSource from "../Sources/RecipientNameSource";
import IssuedDateSource from "../Sources/IssuedDateSource";
import TextSource from "../Sources/TextSource";
import TextBlock from "../Blocks/TextBlock";
import QrSource from "../Sources/QrSource";
import QrBlock from "../Blocks/QrBlock";
import LinkSource from "../Sources/LinkSource";
import LinkBlock from "../Blocks/LinkBlock";

import "draft-js/dist/Draft.css";
import "draftail/dist/draftail.css";
import "./DraftCert.css";

import { JSONParse } from "@cti-workspace/helpers";

const css = `@media print {
	html, body{
		height:100%;
		width:100%;
		margin:0;
		overflow:hidden;
		-webkit-text-size-adjust: none;
	}

	.certificate {
		display:flex;
		justifyContent-content:center;
		align-items:center;
		}
}
@page {size: A4 landscape; margin: 15mm 15mm 15mm 15mm;  }
`;

const DraftRenderer = (props) => {
	let parsedStyle = JSONParse(props.styleString);
	let parsedData = JSONParse(props.data);
	return (
		<div style={parsedStyle.value}>
			{props?.printOrientation && props?.printOrientation === "portrait" && (
				<div style={{ display: "none" }}>
					<style>{`@page {size: A4 portrait; margin: 15mm 15mm 15mm 15mm;}`}</style>
				</div>
			)}
			{/* <style dangerouslySetInnerHTML={{__html: css}} /> */}
			<DraftailEditor
				rawContentState={parsedData.value}
				enableHorizontalRule
				enableLineBreak
				textAlignment={"center"}
				className="certificate"
				entityTypes={[
					{
						type: ENTITY_TYPE.IMAGE,
						label: "Sqr Img",
						description: "Add Square Image",
						attributes: ["src", "styleString"],
						source: ImageSource,
						block: ImageBlock,
						whitelist: {
							src: "^http",
						},
					},
					{
						type: ENTITY_TYPE.LINK,
						label: "Link",
						description: "Add anchor tag",
						attributes: ["href", "val", "styleString"],
						source: LinkSource,
						block: LinkBlock,
						whitelist: {
							src: "^http",
						},
					},
					{
						type: "WIDE_IMAGE",
						label: "wide Img",
						description: "Add Wide Image",
						attributes: ["src", "alt", "styleString"],
						source: FullImageSource,
						block: FullImageBlock,
						whitelist: {
							src: "^http",
						},
					},
					{
						type: "ISSUER_IMG",
						label: "Issuer Img",
						description: "Add Wide Image",
						attributes: ["src", "alt", "styleString"],
						source: FullImageSource,
						block: FullImageBlock,
						whitelist: {
							src: "^http",
						},
					},
					{
						type: "CRED_IMG",
						label: "Cred Img",
						description: "Add Cred Image",
						attributes: ["src", "alt", "styleString"],
						source: ImageSource,
						block: ImageBlock,
						whitelist: {
							src: "^http",
						},
					},
					{
						type: "TextBlock",
						label: "T",
						description: "Add Cred Name",
						attributes: ["val", "styleString"],
						source: TextSource,
						block: TextBlock,
					},
					{
						type: "CRED_NAME",
						label: "Cred Name",
						description: "Add Cred Name",
						attributes: ["val", "styleString"],
						source: CredentialNameSource,
						block: TextBlock,
					},
					{
						type: "QrBlock",
						label: "Qr",
						description: "Add Qr",
						attributes: ["src", "styleString"],
						source: QrSource,
						block: QrBlock,
					},
					{
						type: "RESP_NAME",
						label: "Resp Name",
						description: "Add Resp Name",
						attributes: ["val", "styleString"],
						source: RecipientNameSource,
						block: TextBlock,
					},
					{
						type: "ISD_NAME",
						label: "ISD Name",
						description: "Add Issued Date",
						attributes: ["val", "styleString"],
						source: IssuedDateSource,
						block: TextBlock,
					},
				]}
				topToolbar={null}
				readOnly={true}
			/>
		</div>
	);
};

export default DraftRenderer;

// // import { FrameConnector, renderDocument } from "@govtechsg/decentralized-renderer-react-components";

// const DraftRenderer = forwardRef(({ document, config }, ref) => {
// 	console.log(config);

// 	const parsedData = config.data && JSONParse(config.data);

// 	console.log( parsedData);

// 	return (
// 		<div style={JSONParse(parsedData.style)}>
// 				<DraftailEditor
// 					rawContentState={JSONParse(parsedData.content)}
// 					enableHorizontalRule
// 					enableLineBreak
// 					textAlignment={"center"}
// 					className="certificate"
// 					entityTypes={[
// 						{
// 							type: ENTITY_TYPE.IMAGE,
// 							label: "Sqr Img",
// 							description: "Add Square Image",
// 							attributes: ["src", "styleString"],
// 							source: ImageSource,
// 							block: ImageBlock,
// 							whitelist: {
// 								src: "^http",
// 							},
// 						},
// 						{
// 							type: ENTITY_TYPE.LINK,
// 							label: "Link",
// 							description: "Add anchor tag",
// 							attributes: ["href", "val", "styleString"],
// 							source: LinkSource,
// 							block: LinkBlock,
// 							whitelist: {
// 								src: "^http",
// 							},
// 						},
// 						{
// 							type: "WIDE_IMAGE",
// 							label: "wide Img",
// 							description: "Add Wide Image",
// 							attributes: ["src", "alt", "styleString"],
// 							source: FullImageSource,
// 							block: FullImageBlock,
// 							whitelist: {
// 								src: "^http",
// 							},
// 						},
// 						{
// 							type: "ISSUER_IMG",
// 							label: "Issuer Img",
// 							description: "Add Wide Image",
// 							attributes: ["src", "alt", "styleString"],
// 							source: FullImageSource,
// 							block: FullImageBlock,
// 							whitelist: {
// 								src: "^http",
// 							},
// 						},
// 						{
// 							type: "CRED_IMG",
// 							label: "Cred Img",
// 							description: "Add Cred Image",
// 							attributes: ["src", "alt", "styleString"],
// 							source: ImageSource,
// 							block: ImageBlock,
// 							whitelist: {
// 								src: "^http",
// 							},
// 						},
// 						{
// 							type: "TextBlock",
// 							label: "T",
// 							description: "Add Cred Name",
// 							attributes: ["val", "styleString"],
// 							source: TextSource,
// 							block: TextBlock,
// 						},
// 						{
// 							type: "CRED_NAME",
// 							label: "Cred Name",
// 							description: "Add Cred Name",
// 							attributes: ["val", "styleString"],
// 							source: CredentialNameSource,
// 							block: TextBlock,
// 						},
// 						{
// 							type: "QrBlock",
// 							label: "Qr",
// 							description: "Add Qr",
// 							attributes: ["src", "styleString"],
// 							source: QrSource,
// 							block: QrBlock,
// 						},
// 						{
// 							type: "RESP_NAME",
// 							label: "Resp Name",
// 							description: "Add Resp Name",
// 							attributes: ["val", "styleString"],
// 							source: RecipientNameSource,
// 							block: TextBlock,
// 						},
// 						{
// 							type: "ISD_NAME",
// 							label: "ISD Name",
// 							description: "Add Issued Date",
// 							attributes: ["val", "styleString"],
// 							source: IssuedDateSource,
// 							block: TextBlock,
// 						},
// 						{
// 							type: "COLOR",
// 							label: "Color",
// 							description: "Text Color",
// 							source: ColorSource,
// 							decorator: Color,
// 							attributes: ["color"],
// 						},
// 					]}
// 					topToolbar={null}
// 					readOnly
// 				/>
// 			</div>
// 	);
// });

// export default DraftRenderer;
